<template>
	<b-row v-if="modelId > 0">
		<b-col>
      <b-overlay :show="false" no-wrap rounded />
			<FormGroupBox title="Reseñas">
        <Review 
          v-for="(review,tIndex) in reviews"
          :key="tIndex"
          :review="review">
        </Review>
      </FormGroupBox>
    </b-col>
  </b-row>
</template>

<script>
import FormGroupBox from "@/components/helpers/FormGroupBox"
import Review from "@/components/sections/reviews/ServiceReview"
import { mapActions, mapState } from 'vuex';
export default {
  components: { FormGroupBox, Review },
	props: {
		model: Object,
    modelId: Number
	},
  watch: {
    modelId() {
      this.fetchReviews()
    }
  },
  computed: {
    ...mapState('reservation',['reviews','loadingReviews']),
    viewModel() {
			return this.$store.state.reservation.viewModel;
		},
		user() {
			return this.$root.store.state.currentUser;
		}
  },
  methods: {
    ...mapActions('reservation', ['_fetchReviews']),
    fetchReviews() {
			this._fetchReviews({context:this, modelId:this.modelId});
		},
  },
  mounted() {
    this.fetchReviews()
  },
}

</script>